import React from "react";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  root: {
    margin: 20,
    background: "#FFFFFF",
    border: "1px solid #dadada",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "90vh",
    fontSize: 16,
    fontFamily: "Open Sans",
  },
  centerContainer: {
    textAlignLast: "center",
    position: "relative",
  },
  smallIcon: {
    position: "absolute",
    top: -23,
    right: 28,
  },
  textMargin: {
    // marginTop: 12,
    color: "#333",
    fontSize: 24,
  },
});

const UnderConstruction = ({ classes, text, icon, hideIcons, className }) => {
  return (
    <div className={`${classes.root} ${className?.root}`}>
      <div className={classes.centerContainer}>
        {icon ? (
          icon
        ) : !hideIcons ? (
          <div>
            <svg
              width="150"
              height="116"
              viewBox="0 0 150 116"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M84.1668 69.7117C84.1668 66.17 81.1835 63.3015 77.5001 63.3015H73.2935C72.6635 60.9553 71.7035 58.7438 70.4535 56.7053L73.4268 53.8463C76.0301 51.3431 76.0301 47.2854 73.4268 44.7822C70.8235 42.279 66.6035 42.279 64.0001 44.7822L61.0268 47.6412C58.9068 46.4393 56.6068 45.5162 54.1668 44.9104V40.8656C54.1668 37.3271 51.1835 34.4553 47.5001 34.4553C43.8168 34.4553 40.8335 37.3239 40.8335 40.8656V44.9104C38.3935 45.5162 36.0935 46.4393 33.9735 47.6412L31.0002 44.7822C28.3968 42.279 24.1768 42.279 21.5735 44.7822C18.9702 47.2854 18.9702 51.3431 21.5735 53.8463L24.5468 56.7053C23.2968 58.7438 22.3368 60.9553 21.7068 63.3015H17.5002C13.8202 63.3015 10.8335 66.17 10.8335 69.7117C10.8335 73.2534 13.8168 76.122 17.5002 76.122H21.7068C22.3368 78.4681 23.2968 80.6797 24.5468 82.7181L21.5735 85.5771C18.9702 88.0803 18.9702 92.138 21.5735 94.6412C24.1768 97.1444 28.3968 97.1444 31.0002 94.6412L33.9735 91.7822C36.0902 92.9841 38.3935 93.9072 40.8335 94.513V98.5578C40.8335 102.096 43.8168 104.968 47.5001 104.968C51.1835 104.968 54.1668 102.1 54.1668 98.5578V94.513C56.6068 93.9072 58.9068 92.9841 61.0268 91.7822L64.0001 94.6412C66.6035 97.1444 70.8235 97.1444 73.4268 94.6412C76.0301 92.138 76.0301 88.0803 73.4268 85.5771L70.4535 82.7181C71.7035 80.6829 72.6635 78.4681 73.2935 76.122H77.5001C81.1801 76.122 84.1668 73.2534 84.1668 69.7117Z"
                stroke="#333333"
                strokeOpacity="0.75"
                strokewidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
              />
              <path
                d="M47.4976 79.3282C53.0204 79.3282 57.4975 75.0232 57.4975 69.7128C57.4975 64.4024 53.0204 60.0974 47.4976 60.0974C41.9747 60.0974 37.4976 64.4024 37.4976 69.7128C37.4976 75.0232 41.9747 79.3282 47.4976 79.3282Z"
                stroke="#333333"
                strokeOpacity="0.75"
                strokewidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
              />
              <g clip-path="url(#clip0_421_1796)">
                <g clip-path="url(#clip1_421_1796)">
                  <path
                    d="M131.599 47.8601C132.373 45.4905 131.004 42.9682 128.54 42.2238L125.725 41.3735C125.817 39.6765 125.658 38.0028 125.267 36.3863L127.882 35.0744C130.171 33.9258 131.058 31.211 129.863 29.01C128.669 26.809 125.845 25.9561 123.556 27.1047L120.942 28.4165C119.786 27.1839 118.449 26.1014 116.949 25.203L117.833 22.4967C118.607 20.1293 117.239 17.6049 114.774 16.8604C112.31 16.1159 109.687 17.4322 108.913 19.8018L108.028 22.508C106.263 22.4201 104.523 22.5729 102.842 22.9485L101.477 20.4347C100.283 18.2338 97.4593 17.3808 95.1703 18.5294C92.8813 19.678 91.9942 22.3929 93.1888 24.5938L94.5531 27.1076C93.2711 28.2188 92.1454 29.5044 91.211 30.9468L88.3964 30.0966C85.9343 29.3528 83.3089 30.6684 82.5347 33.038C81.7604 35.4075 83.1294 37.9298 85.5937 38.6743L88.4082 39.5245C88.3168 41.2216 88.4757 42.8952 88.8664 44.5117L86.252 45.8236C83.963 46.9722 83.0759 49.687 84.2705 51.888C85.465 54.089 88.2885 54.9419 90.5775 53.7933L93.1918 52.4815C94.3452 53.7134 95.6845 54.7966 97.1846 55.6951L96.3003 58.4013C95.5268 60.7688 96.895 63.2931 99.3594 64.0376C101.824 64.7821 104.447 63.4658 105.221 61.0962L106.105 58.39C107.87 58.4779 109.611 58.3251 111.292 57.9495L112.656 60.4633C113.851 62.6642 116.674 63.5172 118.963 62.3686C121.252 61.22 122.139 58.5051 120.945 56.3042L119.581 53.7904C120.862 52.6813 121.988 51.3936 122.923 49.9512L125.737 50.8014C128.199 51.5452 130.825 50.2296 131.599 47.8601Z"
                    stroke="#333333"
                    strokeOpacity="0.75"
                    strokewidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                  />
                  <path
                    d="M104.963 46.8826C108.658 47.9989 112.594 46.0235 113.755 42.4705C114.916 38.9175 112.862 35.1323 109.167 34.0161C105.472 32.8998 101.535 34.8751 100.374 38.4281C99.2131 41.9811 101.267 45.7663 104.963 46.8826Z"
                    stroke="#333333"
                    strokeOpacity="0.75"
                    strokewidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_421_1796">
                  <rect
                    width="62.903"
                    height="60.9117"
                    fill="white"
                    transform="matrix(0.957272 0.289188 -0.310587 0.950545 86.4185 2.40393)"
                  />
                </clipPath>
                <clipPath id="clip1_421_1796">
                  <rect
                    width="55.9138"
                    height="54.1437"
                    fill="white"
                    transform="matrix(0.957272 0.289188 -0.310587 0.950545 88.7129 6.63123)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        ) : null}
        <div className={`${classes.textMargin} ${className?.text}`}>{text}</div>
      </div>
    </div>
  );
};

export default withStyles(styles)(UnderConstruction);
